import { useMemo, type ComponentProps } from 'react';
import {
  FlightLeg as KitFlightLeg,
  stopCondition as kitStopCondition,
} from '@voll-intelligence/intelligence-ui-kit';
import { flightLegCopy, legStopsCopy } from './flight_leg_copy.js';
import { useGenUiI18n, type GenUiTranslate } from './i18n.js';

export { flightNumberLabel, segmentStops } from '@voll-intelligence/intelligence-ui-kit';

/*
 * A perna de voo mora no intelligence-ui-kit (#4997). Este módulo segura o
 * caminho antigo durante a migração: liga a perna do kit aos textos do catálogo
 * e ao cadastro de cidades do domain. Sai quando os cards do chat importarem do
 * kit.
 */

/** A condição do trecho (Direto / N paradas) pelo tradutor do chat. */
export function stopCondition(stops: number, t: GenUiTranslate): string {
  return kitStopCondition(stops, legStopsCopy(t));
}

function useLegCopy() {
  const { locale } = useGenUiI18n();
  return { copy: useMemo(() => flightLegCopy(locale), [locale]), locale };
}

export function FlightLeg(props: Omit<ComponentProps<typeof KitFlightLeg>, 'copy' | 'locale'>) {
  const { copy, locale } = useLegCopy();
  return <KitFlightLeg {...props} copy={copy} locale={locale} />;
}
